import { z } from 'zod';
import { PAGINATION } from '../constants/index.js';
// Pagination Query
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce
        .number()
        .int()
        .positive()
        .max(PAGINATION.maxLimit)
        .default(PAGINATION.defaultLimit),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().optional(),
});
// Helper to create paginated response
export function createPaginatedResponse(data, total, page, limit) {
    const totalPages = Math.ceil(total / limit);
    return {
        data,
        meta: {
            total,
            page,
            limit,
            totalPages,
            hasNextPage: page < totalPages,
            hasPrevPage: page > 1,
        },
    };
}
//# sourceMappingURL=pagination.js.map